<template>
  <div>
    <v-row class="px-6 mb-4">
      <v-col cols="4">
        <v-text-field
          v-model="searchInputValue"
          prepend-inner-icon="$magnify"
          outlined
          dense
          single-line
          hide-details="auto"
          :placeholder="$t('spedilink.offers.searchPlaceholder')"
          clearable
        />
      </v-col>
    </v-row>

    <v-data-table
      :items="archives"
      :loading="loading"
      :headers="headers"
      hide-default-footer
      :page="dataTableOptions.page"
      :items-per-page="dataTableOptions.itemsPerPage"
    >
      <template v-slot:no-data>
        <span class="grey--text">{{ $t('spedilink.offers.archiveEmpty') }}</span>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | dateFormat }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          small
          color="primary"
          depressed
          :loading="restoringId === item.id"
          @click="restore(item)"
        >
          {{ $t('spedilink.offers.restore') }}
        </v-btn>
      </template>

      <template v-slot:footer v-if="pageCount > 1">
        <v-pagination v-model="dataTableOptions.page" :length="pageCount" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Service from '@/services'

export default {
  name: 'SpedilinkArchiveTable',
  data () {
    return {
      archives: [],
      loading: false,
      pageCount: 1,
      searchInputValue: '',
      searchTimeout: null,
      restoringId: null,
      dataTableOptions: {
        page: 1,
        itemsPerPage: 15
      },
      headers: [
        { text: this.$t('spedilink.offers.name'), value: 'name' },
        { text: this.$t('spedilink.offers.description'), value: 'description' },
        { text: this.$t('spedilink.offers.company'), value: 'companyName' },
        { text: this.$t('spedilink.offers.owner'), value: 'ownerFullName' },
        { text: this.$t('spedilink.offers.createdAt'), value: 'createdAt' },
        { text: '', align: 'end', width: '140', value: 'actions', sortable: false }
      ]
    }
  },
  async created () {
    await this.loadArchived()
  },
  watch: {
    searchInputValue () {
      this.dataTableOptions.page = 1
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.loadArchived()
      }, 500)
    },
    'dataTableOptions.page' () {
      this.loadArchived()
    }
  },
  methods: {
    async loadArchived () {
      this.loading = true
      try {
        const params = {
          page: this.dataTableOptions.page,
          pageSize: this.dataTableOptions.itemsPerPage
        }
        if (this.searchInputValue) {
          params.search = this.searchInputValue
        }
        const { data } = await Service.get('spedilink/SpediLinkOffers/GetArchivedList', params)
        this.archives = data.results.map(item => ({
          ...item,
          ownerFullName: [item.ownerName, item.ownerSurname].filter(Boolean).join(' ')
        }))
        this.pageCount = Math.ceil(data.count / this.dataTableOptions.itemsPerPage) || 1
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    async restore (item) {
      this.restoringId = item.id
      try {
        await Service.post('spedilink/SpediLinkOffers/Restore', {
          SpediLinkId: item.id
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.offers.restoreSuccess'))
        await this.loadArchived()
      } catch (e) {
        const message = e?.response?.data?.Title || e?.response?.data?.title
        if (message) {
          await this.$store.dispatch('setErrorNotification', message)
        }
      } finally {
        this.restoringId = null
      }
    }
  }
}
</script>
